module.exports = __webpack_public_path__ + "static/media/kaspersky.7c273a83.svg";